var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIconCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 15.6654C4.04634 15.6654 0.833008 12.452 0.833008 8.4987C0.833008 4.54536 4.04634 1.33203 7.99967 1.33203C11.953 1.33203 15.1663 4.54536 15.1663 8.4987C15.1663 12.452 11.953 15.6654 7.99967 15.6654ZM7.99967 2.33203C4.59967 2.33203 1.83301 5.0987 1.83301 8.4987C1.83301 11.8987 4.59967 14.6654 7.99967 14.6654C11.3997 14.6654 14.1663 11.8987 14.1663 8.4987C14.1663 5.0987 11.3997 2.33203 7.99967 2.33203Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6663 9H5.33301C5.05967 9 4.83301 8.77333 4.83301 8.5C4.83301 8.22667 5.05967 8 5.33301 8H10.6663C10.9397 8 11.1663 8.22667 11.1663 8.5C11.1663 8.77333 10.9397 9 10.6663 9Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.6654C7.72667 11.6654 7.5 11.4387 7.5 11.1654V5.83203C7.5 5.5587 7.72667 5.33203 8 5.33203C8.27333 5.33203 8.5 5.5587 8.5 5.83203V11.1654C8.5 11.4387 8.27333 11.6654 8 11.6654Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIconCircle);
export default __webpack_public_path__ + "static/media/addIconCircle.f9880aaa9ca32fafc1605f12bcc5e623.svg";
export { ForwardRef as ReactComponent };